export default "__VITE_ASSET__Cr4Rxx9X__"